import type { PermissionCode } from '@/constants/permissions';
import { useUserInfo } from '@/hooks/useUserInfo';
import { Navigate } from 'react-router-dom';

interface PermissionRouteProps {
  children: React.ReactNode;
  permissions: PermissionCode | readonly PermissionCode[];
  requireAll?: boolean;
  redirectTo?: string;
}

export const PermissionRoute = ({
  children,
  permissions,
  requireAll = false,
  redirectTo = '/404',
}: PermissionRouteProps) => {
  const { data: userInfo, isLoading } = useUserInfo();

  if (isLoading) {
    return (
      <div className="flex min-h-[240px] w-full items-center justify-center">
        <div className="progress" />
      </div>
    );
  }

  const requiredPermissions = Array.isArray(permissions)
    ? permissions
    : [permissions];
  const userPermissions: string[] = Array.isArray(userInfo?.permissions)
    ? userInfo.permissions
    : [];
  const hasPermission = requireAll
    ? requiredPermissions.every((permission) =>
        userPermissions.includes(permission),
      )
    : requiredPermissions.some((permission) =>
        userPermissions.includes(permission),
      );

  if (!hasPermission) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};
